import request from '@/utils/request'


//下单操作
export const customerOrder = (data) => {
    return request({
        url: '/hqprotal/intent/customerOrder',
        method: 'post',
        data
    })
}

//查询下单用户信息
export const getOrderUser = () => {
    return request({
        url: '/hqprotal/information/getOrderUser',
        method: 'get',
    })
}

//产品商城详情
export const productDetails = (id) => {
    return request({
        url: `/hqprotal/productManagement/getInfo/${id}`,
        method: 'get',
    })
}